(function () {
  if (window.turnProductStoryInitialized) return;
  window.turnProductStoryInitialized = true;
  function targetFromHash(hash) {
    if (!hash || !hash.startsWith('#turn-design-story-')) return null;
    return document.getElementById(hash.slice(1));
  }
  function reveal(target, focus) {
    if (!target || target.tagName !== 'DETAILS') return;
    target.open = true;
    if (focus) target.querySelector('summary').focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-turn-story-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = targetFromHash(link.hash);
    if (!target) return;
    event.preventDefault();
    reveal(target, true);
    if (location.hash !== link.hash) history.pushState(null, '', link.hash);
  });
  function revealHash() { reveal(targetFromHash(location.hash), false); }
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', revealHash);
  document.addEventListener('shopify:section:select', function (event) {
    const details = event.target.querySelector('.turn-story__details');
    if (details) details.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealHash);
  else revealHash();
})();
